import instance from "./api_instance.util";

export const PING_EVERY_MS = 5 * 60 * 1000;

// Only an active, visible, signed-in tab extends the server's idle timeout.
export function shouldPing({ now, lastActivity, visible, signedIn }) {
	return Boolean(signedIn && visible && now - lastActivity < PING_EVERY_MS);
}

export function startSessionKeepAlive() {
	let lastActivity = Date.now();
	const touch = () => {
		lastActivity = Date.now();
	};
	["mousedown", "keydown", "scroll", "touchstart"].forEach((evt) =>
		window.addEventListener(evt, touch, { passive: true }),
	);
	setInterval(() => {
		const signedIn =
			sessionStorage.getItem("admin_auth_active") === "true" ||
			localStorage.getItem("admin_auth_remember") === "true";
		const visible = document.visibilityState !== "hidden";
		if (shouldPing({ now: Date.now(), lastActivity, visible, signedIn })) {
			instance.get("/api/v1/admin/auth/me").catch(() => {});
		}
	}, PING_EVERY_MS);
}
